import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { subscribeNewsletterService } from "@crescentParts/Services/CustomNewsletterService";

export interface NewsletterFormParameter {
    firstName: string;
    lastName: string;
    jobTitle: string;
    company: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    typeOfWork: string;
    storeLocation: string;
    email: string;
    onSuccess: () => void;
    onError: (error: string) => void;
}

type HandlerType = Handler<NewsletterFormParameter>;

export const Subscribe: HandlerType = async props => {
    try {
        await subscribeNewsletterService({ newsletterForm: props.parameter });
        props.parameter.onSuccess();
    } catch (err) {
        props.parameter.onError(err?.errorMessage || err);
    }
};

export const chain = [Subscribe];

const subscribeNewsletter = createHandlerChainRunner(chain, "SubscribeNewsletter");
export default subscribeNewsletter;
